import { useState } from 'react';

const FAQS = [
  {
    q: 'What are the best vacation rentals in Highlands, NC?',
    a: 'Glen Falls Luxury Cabin is consistently rated as the top vacation rental in Highlands, NC, with a 5.0-star Airbnb Guest Favorite rating. Other well-regarded options include Laurelwood, Falls Drive Cottage, Whispering Walk, and Stag Ridge — all real properties with verified listings and strong guest reviews. The right choice depends on your group size, budget, and priorities.',
  },
  {
    q: 'Are there luxury cabin rentals in Highlands, NC?',
    a: 'Yes. Highlands, NC has a well-developed luxury cabin rental market. Properties like Glen Falls Luxury Cabin and Stag Ridge offer premium finishes, stone fireplaces, covered decks, and private wooded settings — all within minutes of downtown Highlands. The area attracts travelers who expect more than a generic rental, and the cabin market reflects that.',
  },
  {
    q: 'Are there pet friendly vacation rentals in Highlands, NC?',
    a: 'Yes. Several vacation rentals in Highlands, NC welcome pets. Glen Falls Luxury Cabin is one of the most popular pet-friendly options, offering a wooded setting and easy access to nearby trails. Lark Lodge and Stag Ridge are also pet-friendly. Always confirm the pet policy and any additional fees before booking.',
  },
  {
    q: 'How close are vacation rentals to downtown Highlands?',
    a: 'Most vacation rentals in Highlands, NC are within 5 to 10 minutes of downtown Highlands and Main Street. Glen Falls Luxury Cabin, for example, is just a few minutes\' drive from the town center while still offering a secluded, private setting. Some properties are closer to town, while others are more remote — it\'s worth checking the specific location before booking.',
  },
  {
    q: 'What areas are best to stay in near Highlands?',
    a: 'The most popular areas for vacation rentals near Highlands, NC include the Falls Drive corridor (close to Glen Falls and other waterfalls), the wooded neighborhoods just outside downtown, and the surrounding Nantahala National Forest area. Each offers a different balance of privacy, scenery, and proximity to town. Falls Drive is particularly popular for guests who want to be close to the waterfalls.',
  },
  {
    q: 'Are cabins in Highlands good for families?',
    a: 'Yes. Many cabins and vacation rentals in Highlands, NC are well-suited for families. Properties like Glen Falls Luxury Cabin accommodate up to 6 guests and offer outdoor spaces, full kitchens, and easy access to family-friendly activities like waterfall hikes and downtown Highlands. The area is safe, scenic, and genuinely enjoyable for kids and adults alike.',
  },
  {
    q: 'What is the difference between a cabin rental and a vacation rental in Highlands, NC?',
    a: 'In Highlands, NC, the terms are often used interchangeably. Most vacation rentals in the area are mountain cabins or cabin-style homes. Some properties are more cottage-style or modern mountain homes, but the majority feature the wooded setting, covered decks, and mountain character that define the Highlands rental experience. When people search for "vacation rentals in Highlands, NC," they\'re typically looking for the same type of property as a cabin rental.',
  },
];

export default function VRFAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="bg-[#FAFAF8] py-24 px-6 lg:px-14">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Common Questions</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light">
            Frequently Asked<br /><em className="italic">Questions</em>
          </h2>
          <p className="text-[#5C5850] font-jost text-sm leading-relaxed max-w-lg mx-auto mt-5">
            Answers to the most common questions about vacation rentals in Highlands, NC.
          </p>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq, idx) => (
            <div key={idx} className="bg-white rounded-xl overflow-hidden">
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 px-7 py-5 text-left cursor-pointer"
              >
                <span className="font-cormorant text-lg text-[#1A1A18] font-medium leading-snug">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center shrink-0">
                  <i className={`${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'} text-[#2D4A3E] text-base transition-transform`} />
                </div>
              </button>
              {openIdx === idx && (
                <div className="px-7 pb-6">
                  <div className="w-full h-px bg-[#EDE8E0] mb-5" />
                  <p className="text-[#5C5850] font-jost text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
